import { io } from "socket.io-client";
import React, { useContext, useState, useEffect } from 'react';

const SocketContext = React.createContext();
export function useSocket() { return useContext(SocketContext) }

export default function SocketProvider({ children }) {
    const [socket, setSocket] = useState(null)
    const [socketConnected, setSocketConnected] = useState(null);
    const [globalUserName, setGlobalUserName] = useState('');
    const [opponentUserName, setOpponentUserName] = useState('');
    const [globalWin, setGlobalWin] = useState(0);
    const [globalLose, setGlobalLose] = useState(0);
    const [globalRank, setGlobalRank] = useState(0);
    const [validToGo, setValidToGo] = useState(true);

    const socket_url = {
        production: "https://nestjs-socket-server-production.up.railway.app",
        dev: "http://localhost:3001/",
    }
    //establish socket connection
    useEffect(() => {
        let sk = io(socket_url.production);
        console.log(sk);
        setSocket(sk)
    }, [socket_url.dev])

    useEffect(() => {
        if (!socket) return
        socket.on('connect', () => { setSocketConnected(socket.connected); console.log('Socket connected') })
        socket.on('disconnect', () => { setSocketConnected(socket.connected); console.log('Socket connected') })



    }, [socket])
    function toogleSocketConnection() { socketConnected ? socket.disconnect() : socket() }
    return (
        <SocketContext.Provider value={{
            socket, socketConnected, toogleSocketConnection, globalUserName, setGlobalUserName, opponentUserName,
            setOpponentUserName, globalWin, setGlobalWin, globalLose, setGlobalLose, globalRank, setGlobalRank,
            validToGo, setValidToGo
        }}>
            {children}
        </SocketContext.Provider>
    )

};
